<template>
  <transition name="modal">
    <div class="modal-overlay" style="opacity: 1.09; display: block;">
      <div
        class="modal-wrapper showSweetAlert visible"
        data-custom-class
        data-has-confirm-button="true"
        data-allow-outside-click="false"
        data-has-done-function="true"
        data-animation="pop"
        data-timer="null"
        style="display: block; margin-top: -191px;"
      >
        <spinner v-if="isLoading"></spinner>
        <errors v-if="isVisibleErrorsModal"></errors>
        <div class="modal-close col-sm-12 text-right">
          <button class="modal-button" @click="closeModal()">
            <span class="icon-close"></span>
          </button>
        </div>
        <header class="modal-header">
          <h2 class="modal-title">Comments for note {{transaction.transactionId}}</h2>
        </header>

        <div class="mt-lg">
          <slot name="body">
            <p class="modal-paragraph">Please append your comment below*</p>
            <textarea
              class="form-control"
              name="transactionComment"
              v-model="comment"
              rows="4"
              maxlength="255"
            ></textarea>
          </slot>
        </div>
        <div class="mt-lg">
          <slot name="body">
            <div class="row">
              <div class="col-md-12 text-left">
                <button
                  type="submit"
                  class="btn btn-info btn-lg btn-save-comment"
                  @click="saveComment()"
                >Save comment</button>
              </div>
            </div>
          </slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'editTransactionComment',
  props: {
    closeAction: {
      type: Function,
      required: true,
    },
    transaction: {
      type: Object,
      required: true,
    },
    loadNoteDetail: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      comment: this.transaction.comment,
    };
  },
  computed: {
    ...mapState('errors', ['isVisibleErrorsModal']),
  },
  methods: {
    ...mapActions('transaction', ['saveLostComment']),
    async saveComment() {
      this.isLoading = true;
      await this.saveLostComment({
        id: this.transaction.id,
        comment: this.comment,
      });
      await this.loadNoteDetail();
      this.isLoading = false;
      this.closeModal();
    },
    closeModal() {
      if (typeof this.closeAction === 'function') {
        this.closeAction();
      }
    },
  },
};
</script>

<style scoped>

.icon-close {
  font-size: 0.8em;
  font-weight: 600;
}

.modal-title {
  font-size: 20px;
  margin-bottom: 4px;
}

.modal-paragraph {
  font-weight: bold;
  color: gray;
  margin-bottom: 4px;
  margin-top: 22px;
}
.form-control {
  margin-bottom: 36px;
}

.btn-save-comment {
  background-color: #127285;
  margin-bottom: 0px;
  font-weight: bold;
  font-size: 15px;
}

</style>



// WEBPACK FOOTER //
// EditTransactionComment.vue?2452ad44